module.exports = __webpack_public_path__ + "img/image0-fallback.60a37c5a.jpg";